import { Boost, Easydata, Engage, Instructor, Landingdance, Marketing, Mobileexperince, Multiple, Powerful, Simplified, Simplify, Student } from "../assets/images/images";

const danceData = {
    heading: "The Best Software For Dance Studio",
    subtitle:
        "EasyMembr delivers purpose-built Cloud app or web app for dance studios to simplify your daily operations. From class scheduling and client tracking to payments and reports—EasyMembr system allows you to focus on choreography and creativity while we handle the admin work.",
    trialText: "Get Started Now",
    demoText: "Book A Demo",
    imageSrc: Landingdance,
    infoItems: ["No Card Required", "Cancel Anytime", "Affordable Pricing"],
    FeatureHead: "Features of Dance Studio Management: Organized Classes & Client Growth",
    FeatureDesc: "Uncover the essential tools designed to help dance studios operate smoothly and grow effortlessly.",
    FeaturesDetails: [
        {
            id: 1,
            title: "Simplified Class Scheduling and Booking",
            description: [
                "Easymembr provides an intuitive interface for scheduling dance classes for all skill levels, ensuring smooth management for instructors and students.",
                "Manage rescheduling, class swaps, and waitlists easily, keeping your schedule flexible and updated.",
                "Enable students to book sessions via the website, making participation seamless and engaging.",
            ],
            image: Simplified
        },
        {
            id: 2,
            title: "Student Profile Management & Data Privacy",
            description: [
                "Maintain records of student preferences, class history, and progress to deliver personalized coaching.",
                "Use stored data to nurture student relationships and encourage retention.",
                "Rest easy with robust data protection standards that safeguard personal and payment information.",
            ],
            image: Student

        },
        {
            id: 3,
            title: "Multiple Payment Options & Billing Automation",
            description: [
                "Accept online payments via various gateways including credit/debit cards, wallets, and more.",
                "Automate billing cycles, recurring memberships, and receipts to reduce manual errors.",
                "Track payments for class packs, events, and memberships all in one dashboard.",
            ],
            image: Multiple
        },
        {
            id: 4,
            title: "Powerful Analytics & Custom Reporting",
            description: [
                "Track important KPIs such as enrollment trends, revenue, and attendance metrics.",
                "Generate custom reports to analyze instructor performance, student retention, and financial growth.",
                "Use insights to enhance business strategy and performance optimization.",
            ],
            image: Powerful
        },
        {
            id: 5,
            title: "Mobile Experience for Easy Access",
            description: [
                "Provide members and instructors access to bookings, schedules, and notifications via the web app.",
                "Send alerts, reminders, and updates to improve attendance and communication.",
                "Let staff manage classes, view rosters, and track changes on-the-go.",
            ],
            image: Mobileexperince
        },
        {
            id: 6,
            title: "Instructor Scheduling and Payroll Tracking",
            description: [
                "Assign instructors to classes, track hours worked, and manage substitutes with ease.",
                "Automated payroll calculation saves time and ensures accurate compensation.",
                "Monitor staff feedback and student ratings to continuously improve service quality.",
            ],
            image: Instructor
        },
    ],
    HighlighCardDetails: [
        {
            id: 1,
            subtitle: "BEST DANCE SOFTWARE",
            title: "Book a Demo Now!",
            description: [
                "Take your dance studio to the next level. Try EasyMembr software free and explore how it transforms your workflow!"
            ],
            image: "https://fitgymsoftware.com/images/dance-studio-software/cta-dance.webp",
            links: [
                "Get Full Access Now!",
                "Book A Demo",
                "Check Pricing"
            ],
        }
    ],

    AdvantageHeadText: "Advantages of EasyMembr Dance Studio Management Software",
    AdvantageDescText: "From student engagement to class tracking, EasyMembr Dance Studio Software simplifies your operations and supports the creative energy of your studio.",

    featuresData: [
        // {
        //     title: "Easy Data Migration & Setup",
        //     description: [
        //         "Switch from existing tools without hassle with our expert migration support.",
        //         "Generate insightful reports to analyze performance and financials over time.",
        //         "Design customizable dashboards to reflect KPIs that matter to your studio."],
        //     icon: Easydata
        // },
        {
            title: "Boosted Member Engagement",
            description: [
                "Create personalized member experiences through profiles, progress tracking, and class suggestions.",
                "Engage your community with updates, practice tips, and events.",
                "Send motivational messages or reminders directly from the platform."],
            icon: Engage
        },
        {
            title: "Real-Time Class Management",
            description: [
                "Run online and in-person class bookings from a unified calendar view.",
                "Set class limits, enable auto-waitlists, and track class occupancy for better planning.",
                "Adjust schedules quickly with drag-and-drop tools and instant updates."],
            icon: Boost
        },
        {
            title: "In-App Communication & Promotions",
            description: [
                "Launch targeted campaigns via SMS, WhatsApp, or email.",
                "Promote new classes, performances, or events directly from your dashboard.",
                "Reward referrals and long-time students with in-app promo codes."],
            icon: Marketing
        },
        {
            title: "Dedicated Support & Studio Analytics",
            description: [
                "Multi-channel customer support ensures you’re never stuck.",
                "Track instructor performance, attendance, and class popularity.",
                "Make smart business decisions with accurate insights and real-time reports."],
            icon: Simplify
        },
    ]
};

export default danceData;